import React from "react";

const STYLES = {
  Active: "bg-emerald-100 text-emerald-700",
  Expired: "bg-gray-100 text-gray-600",
  Pending: "bg-amber-100 text-amber-700",
};

const StatusBadge = ({ status }) => (
  <span
    className={`inline-block px-3 py-1 rounded-full text-xs font-bold ${
      STYLES[status] || "bg-gray-100 text-gray-700"
    }`}
  >
    {status}
  </span>
);

export default StatusBadge;
